(function () {
  'use strict';

  // When a customer picks a color (or any variant option) on a product CARD,
  // rewrite that card's product links to carry ?variant=<id> so the product
  // page opens with the chosen variant pre-selected.

  function variantIdFromInput(input) {
    if (!input) return '';
    if (input.tagName === 'SELECT') {
      var opt = input.selectedOptions && input.selectedOptions[0];
      return opt ? (opt.dataset.variantId || '') : '';
    }
    return input.dataset.variantId || '';
  }

  function updateCardLinks(card, variantId) {
    if (!card || !variantId) return;
    card.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;
      try {
        var u = new URL(a.href, window.location.origin);
        u.searchParams.set('variant', variantId);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {
        // Fallback for odd hrefs: strip existing variant param, append fresh.
        var base = href.split('#')[0];
        base = base.replace(/([?&])variant=[^&]*/g, '$1').replace(/[?&]$/, '');
        var sep = base.indexOf('?') === -1 ? '?' : '&';
        a.setAttribute('href', base + sep + 'variant=' + variantId);
      }
    });
  }

  function handle(input) {
    if (!input) return;
    var card = input.closest('.product-item, [data-js-product-component]');
    if (!card) return;
    // Only product cards — skip the main product page picker.
    if (card.hasAttribute('data-main-product-page-variants')) return;
    updateCardLinks(card, variantIdFromInput(input));
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('.product-variant__input, .product-variant-value');
    if (input) handle(input);
  });

  // Swatches are often clicked via their <label>; resolve to the input and
  // update after the radio state settles.
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.product-variant__label');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    if (input) requestAnimationFrame(function () { handle(input); });
  });
})();
